import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'lib-report-buttons',
  templateUrl: './report-buttons.component.html',
  styleUrls: ['./report-buttons.component.css'],
  standalone: false
})
export class ReportButtonsComponent implements OnInit {
  @Input()
  formats: DownloadFormatOption[] = [DownloadFormatOption.CSV(), DownloadFormatOption.PDF()];
  @Input()
  allowHtml: boolean = true;
  @Input()
  downloadButtonStyle: string = 'btn-link';
  @Output()
  generateReport = new EventEmitter();
  @Output()
  downloadReport = new EventEmitter<string>();
  @Input()
  customDownloadButtonText: string | null = null;
  @Input()
  public disabled = false;
  public get buttonText() {
    if (this.customDownloadButtonText != null) {
      return this.customDownloadButtonText;
    }
    if (this.formats.length > 1) {
      return 'Download as...';
    }
    return 'Download';
  }
  constructor() {}

  ngOnInit(): void {}
}

export class DownloadFormatOption {
  name: string;
  icon: string;
  extension: string;

  public static CSV() {
    return {
      name: 'CSV',
      icon: 'fas fa-file-csv',
      extension: 'csv'
    };
  }

  public static PDF() {
    return {
      name: 'PDF',
      icon: 'fas fa-file-pdf',
      extension: 'pdf'
    };
  }

  public static Excel() {
    return {
      name: 'Excel',
      icon: 'fas fa-file-excel',
      extension: 'xlsx'
    };
  }
}
